import { reduxField } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxField.HR.ADDRESS()
export { reducer, actions, saga }
